__turbopack_context__.v({
  "arrow-icon": "SearchInput-module-scss-module__oJidAa__arrow-icon",
  "clear-button": "SearchInput-module-scss-module__oJidAa__clear-button",
  "close-icon": "SearchInput-module-scss-module__oJidAa__close-icon",
  "content": "SearchInput-module-scss-module__oJidAa__content",
  "control": "SearchInput-module-scss-module__oJidAa__control",
  "delete-button": "SearchInput-module-scss-module__oJidAa__delete-button",
  "fade-in-slide-up": "SearchInput-module-scss-module__oJidAa__fade-in-slide-up",
  "fade-out-slide-down": "SearchInput-module-scss-module__oJidAa__fade-out-slide-down",
  "input": "SearchInput-module-scss-module__oJidAa__input",
  "item": "SearchInput-module-scss-module__oJidAa__item",
  "item-text": "SearchInput-module-scss-module__oJidAa__item-text",
  "item-wrapper": "SearchInput-module-scss-module__oJidAa__item-wrapper",
  "magnifying-glass": "SearchInput-module-scss-module__oJidAa__magnifying-glass",
  "recent-searches-label": "SearchInput-module-scss-module__oJidAa__recent-searches-label",
  "trigger": "SearchInput-module-scss-module__oJidAa__trigger",
});
